var _style, _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _line, _path18, _circle, _circle2, _g, _g2, _rect2, _rect3, _ellipse, _circle3, _path19, _rect4, _path20, _path21, _path22, _rect5, _rect6, _defs, _g3, _g4, _g5, _g6, _g7, _g8, _path23, _path24, _path25, _path26, _g9, _g10, _path27, _g11, _g12, _g13, _g14, _path28, _g15, _path29, _path30, _path31, _g16, _path32;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBeaverScreening(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1457.8 1256.7",
    style: {
      enableBackground: "new 0 0 1457.8 1256.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#412412;stroke:#1F130C;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st1{fill:#3690CE;}\r\n\t.st2{fill:#5C3515;}\r\n\t.st3{fill:#68137B;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{fill:#FFFFFF;stroke:#1F130C;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st6{fill:#1F1511;}\r\n\t.st7{fill:#E5AC22;}\r\n\t.st8{fill:#E5AC22;stroke:#1F130C;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st9{fill:none;}\r\n\t.st10{fill:#EF4924;}\r\n\t.st11{fill:#A88057;}\r\n\t.st12{fill:#E5E6E7;}\r\n\t.st13{fill:#666666;}\r\n\t.st14{fill:#5A382E;}\r\n\t.st15{fill:none;stroke:#E5E6E7;stroke-width:7;stroke-miterlimit:10;}\r\n\t.st16{fill:#1E1D1E;}\r\n\t.st17{fill:#2D2D2D;}\r\n\t.st18{fill:#494949;}\r\n\t.st19{fill:url(#SVGID_1_);}\r\n\t.st20{fill:url(#SVGID_2_);}\r\n\t.st21{clip-path:url(#SVGID_3_);}\r\n\t.st22{fill:#4B4DF2;}\r\n\t.st23{fill:#C21BBC;}\r\n\t.st24{fill:#BA1802;stroke:#1F130C;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st25{fill:#EF4924;stroke:#1F130C;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st26{fill:url(#XMLID_8_);stroke:#1F130C;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st27{fill:#124667;}\r\n\t.st28{fill:#D3D3D3;stroke:#1F130C;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st29{fill:#D3D3D3;}\r\n\t.st30{fill:#4B4DF2;stroke:#1F130C;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st31{fill:#1F1612;}\r\n\t.st32{fill:#E4AC23;stroke:#1F130C;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st33{fill:#E4AC23;}\r\n\t.st34{fill:#5A62FF;stroke:#1F130C;stroke-width:10;stroke-miterlimit:10;}\r\n\t.st35{fill:#5A62FF;}\r\n\t.st36{fill:#4B4DF2;stroke:#1F130C;stroke-width:5;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st37{fill:#3D0E53;}\r\n\t.st38{fill:#A5A5A5;stroke:#1F130C;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st39{fill:none;stroke:#1F130C;stroke-width:5;stroke-miterlimit:10;}\r\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M484.2,248.3c6-1.7,11.6-4.9,16.3-9.6c14.8-14.8,14.8-39,0-53.8c-7.4-7.4-17.1-11.1-26.9-11.1 c-9.7,0-19.5,3.7-26.9,11.1c-6,6-9.6,13.6-10.7,21.4c0,0-0.6-0.6-1.7-1.7c-3.3-4.1-6.9-8.2-10.8-12.4c-3.8-4.2-7.9-8.4-12.3-12.6 c-33.6-32.2-83.6-64.1-153.9-72.6c0,0,16,11.3,31,27.3c-30.4-4.5-64.7-4.1-102.3,5c0,0,41,10.9,65.2,31.9c1.6,1.4,3.2,2.9,4.7,4.4 c1.4,1.5,2.7,3,4,4.5c-19,6.1-37.2,14.9-54.1,26.1c-1.1-7.9-4.7-15.4-10.7-21.4c-7.4-7.4-17.1-11.1-26.9-11.1 c-9.7,0-19.5,3.7-26.9,11.1c-14.8,14.8-14.8,39,0,53.8c4.7,4.7,10.3,7.9,16.3,9.6c-40.8,45.6-83,84.6-79.6,218.2 c0.9,36,16.6,102,22.1,121l0,0c0,0,0.1,0.1,0.2,0.4c0.8,2.6,1.3,4.2,1.5,4.7c0.1,0.1,0.1,0.3,0.2,0.4c1,2,2.1,4.1,3.3,6.2 c2,4.6,5.4,12,8.7,19.2h383.4L311.5,638H116.5c17,28.3,38,52.7,61.9,72h0c4.7,3.8,9.5,7.4,14.4,10.8c6.7,4.6,14.3,6.8,21.8,6.8 c12.1,0,23.9-5.6,31.5-16.1c0.4-0.5,0.8-1,1.2-1.5h0c14.7-19.3,38-31.9,64.2-31.9l0,0h0h0l0,0c26.2,0,49.4,12.5,64.2,31.9h0 c0.4,0.5,0.8,1,1.2,1.5c7.6,10.5,19.5,16.1,31.5,16.1c7.5,0,15.1-2.2,21.8-6.8c4.9-3.4,9.7-7,14.4-10.8h0 C614.2,519,520.6,289.1,484.2,248.3z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1039.3,
    y: 743.7,
    className: "st1",
    width: 65.3,
    height: 39.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M428.5,458.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M371.8,442.3c-1.2,5.8-2.8,11.3-4.8,16.6c-2.1,5.8-7.1,9.5-12.6,9.5h-20.4c-7.5,0-13.6-6.9-13.6-15.5v-10.7 h-15.9V453c0,8.6-6.1,15.5-13.6,15.5h-20.4c-5.5,0-10.5-3.8-12.6-9.5c-1.9-5.3-3.5-10.9-4.8-16.6H117.2v238.2h378.2V442.3H371.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_84_",
    className: "st4",
    d: "M250.4,423.5c0.1,0,0.2,0,0.2,0c1.1,0,2.1-0.1,3.2-0.1C252.6,423.5,251.5,423.5,250.4,423.5 C250.4,423.5,250.4,423.5,250.4,423.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_83_",
    className: "st4",
    d: "M371.2,423.4c1.1,0,2.1,0.1,3.2,0.1c0.1,0,0.2,0,0.2,0c0,0,0,0,0,0 C373.4,423.5,372.3,423.5,371.2,423.4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_82_",
    className: "st5",
    d: "M262.7,305.6c5.8-7,9.3-16,9.3-25.8c0-23.2-19.6-41.8-43.2-40.2c-19.9,1.4-36,17.5-37.4,37.4 c-1.6,23.6,17,43.2,40.2,43.2c2.4,0,4.7-0.2,7-0.6c4.2-1.5,8.2-3.4,11.8-6C254.7,310.4,258.8,307.8,262.7,305.6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_81_",
    className: "st5",
    d: "M433.6,279.9c0-22.3-18.1-40.3-40.3-40.3c-22.3,0-40.3,18-40.3,40.3c0,9.8,3.5,18.8,9.3,25.8 c3.9,2.2,8,4.8,12.2,7.9c3.6,2.6,7.6,4.6,11.8,6c2.3,0.4,4.6,0.6,7,0.6C415.5,320.2,433.6,302.1,433.6,279.9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_80_",
    className: "st6",
    d: "M401.2,317.8c-11.1,0-20.2-9-20.2-20.2c0-11.1,9-20.2,20.2-20.2c1.6,0,3.1,0.2,4.5,0.5 c-3.8,1-6.7,4.5-6.7,8.6c0,4.9,4,8.9,8.9,8.9c4.9,0,8.9-4,8.9-8.9c0-0.7-0.1-1.3-0.2-2c3,3.5,4.8,8,4.8,13 C421.4,308.8,412.3,317.8,401.2,317.8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_79_",
    className: "st6",
    d: "M239.7,317.8c-11.1,0-20.2-9-20.2-20.2c0-11.1,9-20.2,20.2-20.2c1.6,0,3.1,0.2,4.5,0.5 c-3.8,1-6.7,4.5-6.7,8.6c0,4.9,4,8.9,8.9,8.9c4.9,0,8.9-4,8.9-8.9c0-0.7-0.1-1.3-0.2-2c3,3.5,4.8,8,4.8,13 C259.8,308.8,250.8,317.8,239.7,317.8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_78_",
    className: "st7",
    d: "M473.2,194.4c9.9,0,17.8,8,17.8,17.8c0,9.9-8,17.9-17.8,17.9c-9.9,0-17.8-8-17.8-17.9 C455.4,202.4,463.4,194.4,473.2,194.4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_77_",
    className: "st7",
    d: "M148.5,212.2c0-9.9,8-17.8,17.8-17.8c9.9,0,17.8,8,17.8,17.8c0,9.9-8,17.9-17.8,17.9 C156.5,230.1,148.5,222.1,148.5,212.2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_76_",
    className: "st4",
    d: "M373.1,436.4c-1.3,8.3-3.4,16.3-6.1,23.7c-2.1,5.8-7.1,9.5-12.6,9.5h-20.4 c-7.5,0-13.6-6.9-13.6-15.5v-36.9c3.5,2.8,7.3,5.4,11.3,7.7C344.2,432,358.4,436,373.1,436.4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_75_",
    className: "st4",
    d: "M304.5,417.3v36.9c0,8.6-6.1,15.5-13.6,15.5h-20.4c-5.5,0-10.5-3.8-12.6-9.5 c-2.7-7.4-4.8-15.4-6.1-23.7c14.7-0.5,29-4.4,41.4-11.5C297.2,422.7,301,420.1,304.5,417.3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_52_",
    className: "st5",
    d: "M373.1,419.6c-1.3,8.3-3.4,16.3-6.1,23.7c-2.1,5.8-7.1,9.5-12.6,9.5h-20.4 c-7.5,0-13.6-6.9-13.6-15.5v-36.9c3.5,2.8,7.3,5.4,11.3,7.7C344.2,415.2,358.4,419.1,373.1,419.6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_50_",
    className: "st5",
    d: "M304.5,400.4v36.9c0,8.6-6.1,15.5-13.6,15.5h-20.4c-5.5,0-10.5-3.8-12.6-9.5 c-2.7-7.4-4.8-15.4-6.1-23.7c14.7-0.5,29-4.4,41.4-11.5C297.2,405.8,301,403.2,304.5,400.4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_74_",
    className: "st6",
    d: "M307.8,321.4c1.6-0.1,3.1-0.1,4.7-0.1c1.6,0,3.1,0,4.7,0.1c20.5,0.8,39.7,6.9,39.7,18.3 c0,8.6-2.4,16.6-6.6,23.3c-7.8,12.6-21.8,21-37.7,21c-15.9,0-29.9-8.4-37.7-21c-4.2-6.8-6.6-14.8-6.6-23.3 C268.1,328.3,287.3,322.2,307.8,321.4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_71_",
    className: "st8",
    d: "M181.9,363c0,7.8,1.7,15.2,4.7,22.1c10,22.5,34.7,38.4,63.7,38.5c0.1,0,0.2,0,0.2,0 c1.1,0,2.1-0.1,3.2-0.1c18.8-0.8,46.9-18.7,46.9-18.7s1.6-1.4,3.8-2.9c2.4-1.6,5.5-3.4,8-3.4c2.4,0,5.5,1.7,8,3.4 c2.2,1.5,3.8,2.9,3.8,2.9s28.1,17.9,46.9,18.7c1.1,0,2.1,0.1,3.2,0.1c0.1,0,0.2,0,0.2,0c29-0.1,53.7-16,63.7-38.5 c3-6.8,4.7-14.3,4.7-22.1c0-6.4-1.7-10.8-4.7-14c-12.7-13.5-48.3-4.1-73-22.2c-2.7-2-5.3-3.7-7.8-5.2c-2.8-2-6.3-4-10.8-5.6 c-7.3-2.7-16.5-4.4-26.5-5c-2.5-0.1-5.1-0.2-7.7-0.2c-2.6,0-5.2,0.1-7.7,0.2c-9.9,0.6-19.1,2.3-26.5,5c-4.5,1.7-8,3.6-10.8,5.6 c-2.5,1.5-5.1,3.2-7.8,5.2c-24.7,18.1-60.3,8.8-73,22.2C183.7,352.1,181.9,356.6,181.9,363 M268.1,339.7 c0-11.4,19.2-17.5,39.7-18.3c1.6-0.1,3.1-0.1,4.7-0.1c1.6,0,3.1,0,4.7,0.1c20.5,0.8,39.7,6.9,39.7,18.3c0,8.6-2.4,16.6-6.6,23.3 c-7.8,12.6-21.8,21-37.7,21c-15.9,0-29.9-8.4-37.7-21C270.5,356.2,268.1,348.2,268.1,339.7"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_70_",
    className: "st9",
    x1: 45.5,
    y1: 615.2,
    x2: 246.2,
    y2: 509.9
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M330.8,474.9l-12.4,7.4c-1.6,0-18.9,0-20.6,0l-12.4-7.4c-4.9,0-8.9,4-8.9,8.9v26.3c0,4.9,4,8.9,8.9,8.9 l12.4-7.4c3.1,0,12.5-3.6,13.3-3.8c1.6,2.3,4.3,3.8,7.3,3.8l12.4,7.4c4.9,0,8.9-4,8.9-8.9v-26.3 C339.8,478.9,335.7,474.9,330.8,474.9z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_62_",
    className: "st11",
    cx: 297.3,
    cy: 566,
    r: 10.9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_61_",
    className: "st11",
    cx: 297.3,
    cy: 592.1,
    r: 10.9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_54_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_60_",
    className: "st12",
    d: "M245,553.2v82.7c0,8.1,20.7,14.6,46.3,14.6s46.3-6.5,46.3-14.6v-82.7H245z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_56_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_59_",
    className: "st13",
    d: "M334.2,558.8c2.2-1.7,3.5-3.6,3.5-5.5c0-8.1-20.7-14.6-46.3-14.6s-46.3,6.5-46.3,14.6 c0,2,1.2,3.8,3.5,5.5c6.9-5.3,23.5-9.1,42.9-9.1C310.7,549.7,327.3,553.5,334.2,558.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_57_",
    className: "st14",
    cx: 291.3,
    cy: 558.8,
    rx: 42.9,
    ry: 9.1
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_55_",
    className: "st15",
    d: "M246.7,617.3c-11.3,0-20.4-9.1-20.4-20.4s9.1-20.4,20.4-20.4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_51_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_53_",
    className: "st2",
    d: "M218.3,549c0,0,0.3,0.1,0.7,0.5c0.1,0.1,0.2,0.2,0.4,0.3c0.1,0.1,0.3,0.3,0.3,0.3 c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0-0.2,0c-0.1,0-0.2-0.1-0.4-0.1c-0.2,0-0.7-0.4-1.2-0.6c-0.4-0.2-1.1-0.7-1.7-1.1 c-0.6-0.4-1.4-1-2.1-1.6c-0.8-0.6-1.6-1.3-2.5-2c-0.9-0.7-1.8-1.6-2.8-2.4c-1.9-1.7-4-3.7-6.2-5.8c-2.2-2.1-4.4-4.4-6.7-6.7 c-2.3-2.4-4.6-4.8-6.9-7.3c-6.2-6.7-12.4-13.7-17.7-20l-58.1,39.9c3.6,6.2,7.5,12.8,11.6,19.5c2,3.2,4.1,6.4,6.1,9.6 c2.1,3.2,4.2,6.3,6.4,9.4c2.2,3.1,4.3,6.1,6.5,9c1.1,1.5,2.2,2.8,3.3,4.2c1.1,1.4,2.2,2.7,3.4,4.1c1.1,1.3,2.2,2.6,3.5,3.9 c1.2,1.3,2.3,2.4,3.5,3.6c1.2,1.2,2.3,2.2,3.6,3.4c0.6,0.6,1.2,1.1,1.8,1.6c0.6,0.5,1.1,1,1.8,1.5c1.3,1,2.5,1.9,3.6,2.7 c0.5,0.4,1.2,0.8,1.8,1.2c0.6,0.4,1.1,0.7,1.6,1c2,1.2,3,1.8,3,1.8c21.4,10.8,48.5,4,60.6-15.3S239.7,559.8,218.3,549z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 520.1,
    y: 546.2,
    className: "st16",
    width: 62.9,
    height: 21.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 597.1,
    y: 576.4,
    className: "st16",
    width: 21.2,
    height: 511.2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9732 -0.2298 0.2298 0.9732 -114.3696 131.3829)",
    className: "st17",
    cx: 507,
    cy: 556.8,
    rx: 23.4,
    ry: 23.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 607.7,
    cy: 556.8,
    r: 31.3
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M642.4,1074.6h-69.5c-7.3,0-13.2,5.9-13.2,13.2l0,0h96l0,0C655.7,1080.5,649.7,1074.6,642.4,1074.6z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 531.6,
    y: 1083.3,
    className: "st16",
    width: 152.1,
    height: 13.2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M607.7,542.2c-8.1,0-14.6,6.5-14.6,14.6c0,8.1,6.5,14.6,14.6,14.6c8.1,0,14.6-6.5,14.6-14.6 C622.2,548.8,615.7,542.2,607.7,542.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 335.8524,
    y1: 549.7633,
    x2: 801.2744,
    y2: 549.7633
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M798.5,396c-1.1,0.1-1.9,1-1.8,2.1c0.1,0.6,4.9,64.7-12.7,133.1c-16.2,62.8-55.2,142.3-149.1,164.1 c-93.9,21.8-169-47.4-215.6-109.3c-50.7-67.4-79.3-141-79.6-141.8c-0.4-1-1.5-1.5-2.6-1.1c-1,0.4-1.5,1.5-1.1,2.6 c0.3,0.7,29.1,74.8,80.1,142.7c30,39.9,61.7,70,94.2,89.3c37.9,22.5,76.9,30.3,116.3,23.5c3.1-0.5,6.1-1.2,9.2-1.9 c42.4-9.9,77.4-31.9,104.2-65.5c21.3-26.8,37.5-61,47.9-101.6c17.7-69,12.9-133.6,12.8-134.3C800.5,396.7,799.6,395.9,798.5,396z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M750,468.6c-1-0.5-2.2,0-2.6,1c-0.2,0.4-18.5,40-50.9,80.6c-29.7,37.3-77.7,83-137.5,89 c-66.9,6.8-135-36.4-202.4-128.3c-0.6-0.9-1.9-1.1-2.8-0.4c-0.9,0.6-1.1,1.9-0.4,2.8c68.3,93.2,137.6,136.9,206,129.9 c3.3-0.3,6.6-0.8,9.9-1.4c23.7-4.1,47.3-14.4,70.1-30.7c20.8-14.8,41-34.5,60.2-58.5c32.6-40.9,51.1-80.9,51.3-81.3 C751.4,470.2,751,469,750,468.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 103.5,
    y: 431.3,
    className: "st16",
    width: 403.5,
    height: 261.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.2393,
    y1: 561.3802,
    x2: 495.4417,
    y2: 561.3802
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 117.2,
    y: 442.3,
    className: "st20",
    width: 378.2,
    height: 238.2
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: 117.2,
    y: 442.3,
    width: 378.2,
    height: 238.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st22",
    cx: 195.7,
    cy: 694.9,
    r: 18.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st23",
    cx: 220.9,
    cy: 703.1,
    r: 18.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st22",
    cx: 215.5,
    cy: 617.6,
    r: 18.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st22",
    cx: 246.3,
    cy: 625.5,
    r: 18.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.1,
    y: 620.6,
    transform: "matrix(-0.9687 -0.2481 0.2481 -0.9687 273.4794 1355.4368)",
    className: "st22",
    width: 34.1,
    height: 79.8
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st23",
    cx: 400.9,
    cy: 703.8,
    r: 18.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st22",
    cx: 424.8,
    cy: 696.9,
    r: 18.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st22",
    cx: 379.7,
    cy: 627.8,
    r: 18.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st22",
    cx: 410.8,
    cy: 621.6,
    r: 18.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.2,
    y: 623.7,
    transform: "matrix(-0.981 0.1942 -0.1942 -0.981 929.6054 1236.043)",
    className: "st22",
    width: 34.1,
    height: 79.8
  })))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1241.8,1133.2h-64.5V779.1h-14.7v354.1h-66.3c-9,0-16.3,7.3-16.3,16.3h82.6h14.7h80.8 C1258.1,1140.5,1250.8,1133.2,1241.8,1133.2z"
  })))))))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M969.7,1112.4h-64.5V660.8h-14.7v451.6h-66.3c-9,0-16.3,7.3-16.3,16.3h82.6h14.7H986 C986,1119.7,978.7,1112.4,969.7,1112.4z"
  })))))))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1209.3,447.4l-89.1,377l208.7-21.1l69.8-386.6H1249C1230,416.6,1213.6,429.4,1209.3,447.4z"
  })))))))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M1399.3,416.7c-9.2-2-18.3,3.9-20,12.9l-63.5,334.2c-2.1,11-12,19-23.5,19c-71.4,0-310.7,0-310.7,0 c-15.1,0-27.4,11.9-27.4,26.7c0,14.7,12.3,26.7,27.4,26.7h330.5c10.5,0,19.5-5.7,24.2-14c1.9-2.1,3.2-4.7,3.8-7.6 l71.9-378.6C1413.6,427.2,1408.1,418.6,1399.3,416.7z"
  })))))))))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1236.9,782.4c0,0-58.3,16.1-86.7,31.6c-28.3,15.5-99.2,19.5-88.7-13.4s43.3-51.8,43.3-51.8l113.2,10.8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1049.1,783.3c0,0-1.2-2.9-29.6,12.6s-99.2,19.5-88.7-13.4c10.5-33,88.2-49.8,88.2-49.8l68.2,8.7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5061_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 1270.4746,
    y1: 385.6645,
    x2: 1361.6555,
    y2: 385.6645
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5128_",
    className: "st26",
    d: "M1313.1,361.9c-13,0.2-27.5-1.7-42.6-1.8c4.1,15.1,5.2,32.2,3.9,50.2l0,0 C1370.6,418.7,1392.8,360.8,1313.1,361.9z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5127_",
    className: "st27",
    d: "M1098.2,308.9c13.1,2.5,27.9,3.3,43.1,5.9c-6.8,14.2-10.8,30.8-12.8,48.7l0,0 C1030.6,354.6,1018.5,293.6,1098.2,308.9z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5083_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5120_",
    className: "st28",
    d: "M1246.3,536.3c25.5-9.1,81.4-11.6,88.2-11.8c3.6,19.4,5.4,39.6,5,60.4 c-0.4,18.7-6.4,47.1-12,69.5l-103.6-5.4L1246.3,536.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1280.5,403.8c12.3-5.1,20.4-17.7,19.2-31.7c-1.6-17.2-16.7-29.8-33.9-28.2c-4.7,0.4-9.1,1.9-12.9,4.1 c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1c-6.8,4-11.9,10.5-14.1,18.2c-13.2-8.8-27.2-15.9-42-20.9c1-1.3,2.2-2.5,3.4-3.7 c1.2-1.2,2.6-2.4,3.9-3.6c20.3-17,54.5-25.3,54.5-25.3c-30.9-8.1-59.3-9.1-84.6-5.9c12.7-13,26.1-22.1,26.1-22.1 c-58.3,5.8-104.2,29.3-133.9,54c-7.6,6.3-14.7,12.1-21.4,17.5c-6.7-11.7-19.7-19-34-17.7c-19.5,1.8-33.8,19-32,38.5 c1.1,11.9,8,21.9,17.6,27.5c-20.4,29.4-41,76.7-49.7,121.6c-2.7,13.7-4.3,27.8-5.1,42.2c11.9,9.1,35.7,25.9,64,38.9 c7.8,5.2,44.9,21.1,75.7,18c70.2-2.7,143.5-49.9,165.3-74.5c20-22.7,80.6-25.5,90.2-25.8C1327.9,477.9,1308,436,1280.5,403.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5086_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5123_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5124_",
    className: "st9",
    d: "M1006.9,607.9c-0.5-0.2-1-0.4-1.5-0.7c-1.2-3.4-2-5.3-2-5.3S1004.8,604,1006.9,607.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5116_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5122_",
    className: "st28",
    d: "M961.4,687.5c-1-1.9-2-3.8-2.8-5.6c-0.2-0.4-0.6-1.7-1.2-3.9c-0.1-0.2-0.1-0.3-0.1-0.3 l0,0c-4.2-15.8-16.9-70.7-16.3-100.5c0.1-3,0.2-5.9,0.4-8.9c7,5.3,18,13.3,31.6,21.6L963,692.5 C961.9,689.4,961.4,687.5,961.4,687.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5119_",
    className: "st29",
    d: "M1009.3,640.4l2.7-30.3c21.8,9.3,45.9,16,69.1,15.1c47.5-1.8,96.5-24.1,129.9-45.9 l-10.5,64.2L1009.3,640.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5117_",
    className: "st30",
    d: "M1012.1,610.1l-2.7,30.3l191.2,3.2l10.5-64.2c15.9-10.4,28.4-20.7,35.4-28.7 c5.7-6.4-18.5,93.5-18.5,93.5l101.6,10.5c-2.1,8.3-4.1,15.8-5.8,21.7c0,0,0,0,0,0c-5.3,23.9-20.8,47-21.1,48 c-23.6,62.1-56.4,62.1-80,62.1c0,0-35.2-5.3-51.2-14.3c-65.2-36.8-103.6,4.7-122.3,11.2c0,0,0-34.5-70.9-37.7 c-11.6-8.1-11.7-42.7-15.3-53.2l10.1-102.6c9.7,5.9,20.6,11.9,32.4,17.3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5087_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5088_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5110_",
    className: "st5",
    d: "M1095.1,533.9l-0.6,30.5c-0.1,7.1,4.8,12.9,11,13l16.9,0.3c4.6,0.1,8.7-2.9,10.6-7.7 c2.4-6.1,4.2-12.7,5.4-19.5c-12.2-0.6-23.9-4.1-34.1-10.2C1101,538.5,1097.9,536.3,1095.1,533.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5109_",
    className: "st5",
    d: "M1083.8,532.7l-1.8,30.5c-0.4,7.1-5.8,12.5-12,12.1l-16.9-1c-4.5-0.3-8.5-3.6-9.9-8.5 c-1.9-6.3-3.2-12.9-3.9-19.9c12.2,0.3,24.1-2.2,34.8-7.4C1077.5,536.8,1080.8,534.9,1083.8,532.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5107_",
    className: "st31",
    d: "M1093.9,468.5c-1.3-0.1-2.6-0.1-3.9-0.2c-1.3,0-2.6,0-3.9,0c-17,0.3-33,5-33.2,14.5 c-0.1,7.1,1.7,13.7,5.1,19.4c6.3,10.6,17.7,17.8,30.9,18c13.2,0.3,24.9-6.5,31.6-16.8c3.6-5.5,5.7-12.1,5.9-19.2 C1126.7,474.8,1110.9,469.5,1093.9,468.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5104_",
    className: "st32",
    d: "M1193.8,493.3c-10.3-11.4-39.9-4.2-60.1-19.6c-2.2-1.7-4.3-3.2-6.4-4.5 c-2.3-1.7-5.2-3.4-8.9-4.8c-6-2.4-13.6-3.9-21.8-4.6c-2.1-0.2-4.2-0.3-6.4-0.3c-2.2,0-4.3,0-6.4,0.1c-8.2,0.3-15.9,1.6-22,3.7 c-3.7,1.3-6.7,2.8-9,4.5c-2.1,1.2-4.3,2.6-6.5,4.2c-20.8,14.6-50.1,6.3-60.8,17.2c-2.5,2.6-4,6.2-4.1,11.5 c-0.1,6.4,1.1,12.6,3.5,18.3c7.9,18.8,28.1,32.4,52.1,32.9c0.1,0,0.1,0,0.2,0c0.9,0,1.8,0,2.6,0c15.6-0.3,39.2-14.7,39.2-14.7 s1.4-1.1,3.2-2.3c2-1.3,4.6-2.7,6.6-2.7c2,0,4.6,1.5,6.5,2.9c1.8,1.3,3.1,2.5,3.1,2.5s23,15.3,38.6,16.2 c0.9,0.1,1.7,0.1,2.6,0.1c0.1,0,0.1,0,0.2,0c24,0.4,44.7-12.4,53.4-30.8c2.6-5.6,4.1-11.7,4.3-18.2 C1197.5,499.7,1196.2,496,1193.8,493.3z M1120.6,503.5c-6.7,10.3-18.4,17-31.6,16.8c-13.2-0.3-24.6-7.5-30.9-18 c-3.4-5.7-5.2-12.3-5.1-19.4c0.2-9.4,16.2-14.1,33.2-14.5c1.3,0,2.6,0,3.9,0c1.3,0,2.6,0.1,3.9,0.2c17,1,32.7,6.4,32.6,15.8 C1126.4,491.3,1124.2,497.9,1120.6,503.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5102_",
    className: "st5",
    d: "M1148.7,460.6c3.1,2.4,6.5,4.1,10.1,5.5c2,0.4,4,0.6,6.1,0.7c22.8,0.5,41-21,34.5-45 c-3-11.1-11.6-20-22.5-23.4c-23.8-7.5-45.9,9.8-46.4,32.6c-0.2,8.5,2.7,16.4,7.6,22.6C1141.6,455.4,1145.1,457.8,1148.7,460.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5089_",
    className: "st31",
    d: "M1148.8,451.9c11.2,1.7,20.9-7.4,20.2-18.6c-0.4-6.5-4.7-12.1-10.6-14.8 c-3.7-1.7-7.2-1.8-10.5-1.1c3.8,1,6.4,4.8,5.5,9c-0.6,3.1-3.2,5.6-6.4,6.1c-4.9,0.7-9.1-3.1-9-7.8c0-0.6,0.1-1.2,0.2-1.7 c-3.2,3.6-4.9,8.5-4.2,13.8C1135,444.5,1141.1,450.8,1148.8,451.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_86_",
    className: "st5",
    d: "M1022.4,452.4c3.1,2.4,6.5,4.1,10.1,5.5c2,0.4,4,0.6,6.1,0.7c22.8,0.5,41-21,34.5-45 c-3-11.1-11.6-20-22.5-23.4c-23.8-7.5-45.9,9.8-46.4,32.6c-0.2,8.5,2.7,16.4,7.6,22.6C1015.3,447.3,1018.8,449.6,1022.4,452.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_58_",
    className: "st31",
    d: "M1022.5,443.8c11.2,1.7,20.9-7.4,20.2-18.6c-0.4-6.5-4.7-12.1-10.6-14.8 c-3.7-1.7-7.2-1.8-10.5-1.1c3.8,1,6.4,4.8,5.5,9c-0.6,3.1-3.2,5.6-6.4,6.1c-4.9,0.7-9.1-3.1-9-7.8c0-0.6,0.1-1.2,0.2-1.7 c-3.2,3.6-4.9,8.5-4.2,13.8C1008.7,436.3,1014.8,442.6,1022.5,443.8z"
  })))), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_5085_",
    className: "st33",
    cx: 1268.6,
    cy: 375,
    r: 19.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_5084_",
    className: "st33",
    cx: 1009.8,
    cy: 371,
    r: 15.8
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5077_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M1286.2,358.4c9.1-29.4,19.8-94.8-51.5-122.3c-0.6-0.4-1.3-0.8-1.9-1.2c-0.8-0.6-1.7-1.1-2.5-1.6 c-12.1-7-26.5-12.5-43.5-15.6c-2.7-0.5-5.5-1-8.4-1.4c-8.1-1-15.9-1.7-23.3-2c-0.1,0-0.4,0.1-0.7,0 c-66.8-2.1-109.3,27.6-128.4,68.4c-4.4,9.4-7.6,19.5-9.5,29.8c-0.3,1.4-0.5,2.8-0.7,4.2c-4.3,26.4-5.3,64.1-0.9,62 c11.6-16.9,42.2-27.6,81-31.7c0,0,0,0,0,0c0,0,0,0,0,0l184.9,25.9c0,0,1.7-3.6,3.8-9.7C1285.2,362,1285.7,360.4,1286.2,358.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5082_",
    className: "st22",
    d: "M1280.2,368c-7.2-8.2-16.6-6.6-55.5-14.2c-44.1-8.6-90.4-10.8-128.8-6.6 c-38.8,4.2-69.4,14.9-81,31.7c-4.3,2.1-3.4-35.6,0.9-62c0.2-1.5,0.4-2.9,0.7-4.2c1.9-10.4,5.1-20.4,9.5-29.8 c19.1-40.8,61.6-70.5,128.4-68.4c0.3,0.1,0.5,0,0.7,0c7.5,0.3,15.2,0.9,23.3,2c2.9,0.4,5.6,0.8,8.4,1.4 c17,3.1,31.4,8.6,43.5,15.6c0.9,0.5,1.7,1,2.5,1.6c30.9,18.8,46.3,48,52.2,74C1292.4,341.1,1286.2,368.7,1280.2,368z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5081_",
    className: "st35",
    d: "M1014.9,379c11.6-16.9,42.2-27.6,81-31.7c38.3-4.2,84.6-2,128.8,6.6 c39,7.6,48.3,6,55.5,14.2c6,0.7,12.3-26.9,4.9-59.1c-5.9-26-21.3-55.2-52.2-74c24.9,23.2,18.9,70.4,18.1,85.4 c-0.9,17.1-47.4,11.5-121.6,15.5C1055.1,339.9,1019.2,361,1014.9,379z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5079_",
    className: "st35",
    d: "M1095.9,347.2c-1.6-57.8-10.7-144.1,113-118.6c127.4,26.3,71.9,144.5,71.9,144.5 L1095.9,347.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5078_",
    className: "st36",
    d: "M1349.5,367c-32.1-7.1-46,6.5-118.1,15.8c-54.7,7.1-101.5-20.6-135.5-35.6 c14.2-8.9,141.4-4.2,209.7,8.6C1323.4,359.1,1346.6,365.9,1349.5,367z"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5062_",
    className: "st0",
    d: "M1219.8,596.7c0,0-0.5,0.6-1.3,1.7c-0.4,0.5-1,1.2-1.6,2c-0.3,0.4-0.6,0.8-1,1.3 c-0.2,0.2-0.4,0.5-0.6,0.7l-0.1,0.2l-0.1,0.1l0,0l0,0c0-0.1,0.1-0.2,0.3-0.3c0.1,0,0.2,0,0.3,0c-0.2,0.2-0.4,0.4-0.6,0.5 c-0.2,0.2-0.4,0.4-0.6,0.6c-0.2,0.2-0.4,0.5-0.7,0.7c-0.6,0.4-1.1,0.9-1.7,1.5c-0.7,0.5-1.5,1-2.2,1.6c-0.9,0.5-1.9,1-2.8,1.7 c-1.2,0.5-2.3,1.1-3.5,1.7c-0.7,0.3-1.4,0.5-2.1,0.8c-0.7,0.3-1.4,0.6-2.2,0.8c-0.8,0.2-1.6,0.5-2.4,0.7c-0.4,0.1-0.8,0.3-1.2,0.4 l-1.3,0.3c-0.9,0.2-1.8,0.4-2.7,0.7c-0.9,0.2-1.9,0.4-2.8,0.6c-1,0.2-1.9,0.4-2.9,0.6c-1,0.1-2.1,0.3-3.1,0.4 c-2,0.4-4.3,0.5-6.4,0.7c-2.2,0.2-4.5,0.3-6.7,0.4c-2.3,0-4.6,0.2-6.9,0.1c-2.3,0-4.6,0-7-0.1c-1.2,0-2.3-0.1-3.5-0.1 c-1.2-0.1-2.3-0.1-3.5-0.2c-4.6-0.3-9.1-0.7-13.4-1.2c-4.3-0.5-8.4-1.1-12.1-1.7c-3.8-0.6-7.2-1.3-10.2-1.9 c-3-0.6-5.6-1.2-7.7-1.7c-2-0.5-3.6-0.9-4.6-1.1c-0.4-0.1-0.8-0.2-1-0.2c-0.1,0-0.1,0-0.1,0c0,0,0,0,0,0 c-24.6-8.6-51.4,4.3-60.1,28.8c-8.6,24.6,4.3,51.4,28.8,60.1c0,0,1,0.4,3,1.1c1.7,0.6,4,1.5,6.8,2.4c2.9,1,6.3,2.1,10.3,3.4 c4,1.2,8.4,2.6,13.3,3.9c4.9,1.4,10.3,2.7,16,4c5.7,1.3,11.8,2.5,18.3,3.6c1.6,0.3,3.2,0.5,4.9,0.8c1.7,0.2,3.3,0.5,5,0.7 c3.3,0.5,6.8,0.9,10.3,1.3c3.5,0.4,7.1,0.6,10.7,0.9c3.7,0.2,7.3,0.4,11,0.5c3.8,0,7.5,0.1,11.3,0c1.9-0.1,3.8-0.1,5.7-0.2 c1.9-0.1,3.9-0.3,5.8-0.4c1.9-0.2,3.8-0.3,5.8-0.5c2-0.2,3.9-0.5,5.8-0.7c1-0.1,1.9-0.3,2.9-0.4c1-0.1,2-0.3,2.9-0.5 c2-0.4,3.9-0.7,5.8-1.1c1.9-0.3,3.9-0.8,5.8-1.3c1.9-0.5,3.8-1,5.7-1.4c3.8-1.1,7.6-2.3,11.2-3.5c3.7-1.4,7.3-2.8,10.7-4.3 c3.5-1.6,6.8-3.3,10-4.9c3.2-1.8,6.2-3.6,9.1-5.4c1.4-0.8,2.8-1.9,4.1-2.8c1.3-1,2.6-1.9,3.8-2.8c1.2-0.9,2.4-1.8,3.6-2.7 c1.3-1.1,2.6-2.3,3.8-3.3c2.4-2.2,4.6-4.2,6.6-6.1c0.4-0.4,0.8-0.8,1.1-1.1c0.2-0.2,0.4-0.4,0.6-0.6c0.4-0.4,0.8-0.8,1.1-1.2 c0.7-0.7,1.3-1.3,1.8-1.8c1-1,1.5-1.5,1.5-1.5l0,0c21.9-22.5,21.4-58.4-1.1-80.3c-22.5-21.9-58.4-21.4-80.3,1.1 C1222.3,593.7,1221,595.2,1219.8,596.7z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "910.9,597.4 911.6,597.9 917.6,590.2 916.9,589.7  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "910.7,601.8 911.4,602.3 916.8,595.5 916.1,595.1  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M1084.4,565.8l-21.9-183.7c-1-8.7-8-15.8-15.5-15.8l-300.6,9.9l-5-0.4c-7.7,0-13.9-2.7-12.8,6.2L754,595.3 c0.8,6.4,5,11.5,9.5,11.5h318l-0.1-0.5c4.3,0,7.2-5,6.5-11.1L1084.4,565.8z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M1070.8,565.8l-21.9-183.7c-1-8.7-8-15.8-15.5-15.8H727.1c-7.5,0-12.8,7.1-11.7,15.8l21.9,183.7l3.5,29.4 c0.7,6.1,4.8,11.1,9.1,11.1h318c4.3,0,7.2-5,6.5-11.1L1070.8,565.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M1087.9,595.3l-3.5-29.4l-21.9-183.7c-1-8.7-8-15.8-15.5-15.8l-10.7,0.4c-0.9-0.2-1.9-0.4-2.9-0.4H727.1 c-7.5,0-12.8,7.1-11.7,15.8l21.9,183.7l3.5,29.4c0.7,6.1,4.8,11.1,9.1,11.1h11.4c0.8,0.3,1.5,0.5,2.3,0.5h318l-0.1-0.5 C1085.7,606.4,1088.6,601.4,1087.9,595.3z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1113.9,676.9H616.3c-7.8,0-14.1-6.3-14.1-14.1v-11c0-7.8,6.3-14.1,14.1-14.1h497.6 c7.8,0,14.1,6.3,14.1,14.1v11C1128,670.5,1121.7,676.9,1113.9,676.9z"
  }))))))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st22",
    cx: 172.7,
    cy: 573,
    r: 18.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st22",
    cx: 203.8,
    cy: 566.8,
    r: 18.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st22",
    cx: 157.2,
    cy: 494.7,
    r: 18.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st22",
    cx: 188.3,
    cy: 488.6,
    r: 18.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.6,
    y: 490.6,
    transform: "matrix(0.981 -0.1942 0.1942 0.981 -99.5771 45.3888)",
    className: "st22",
    width: 34.1,
    height: 79.8
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st22",
    cx: 413.7,
    cy: 569.6,
    r: 18.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st22",
    cx: 444.8,
    cy: 576,
    r: 18.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st22",
    cx: 429.8,
    cy: 491.4,
    r: 18.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st22",
    cx: 460.9,
    cy: 497.8,
    r: 18.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.6,
    y: 516.9,
    transform: "matrix(0.2013 -0.9795 0.9795 0.2013 -172.8069 855.9925)",
    className: "st22",
    width: 79.8,
    height: 34.1
  })))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M969.3,638.3L969.3,638.3c0.2-6.3-4.9-11.4-11.2-11.4l-9.7,0c0,0,0,0,0,0l-35.3,0l24.7-125.7l-64,0v0h-9.7 l-24.7,125.7l-45.1,0c-6.3,0-11.6,5.1-11.8,11.4h9.7c0,0,0,0,0,0L969.3,638.3z"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M332.5,575c-6.7,0-14-1.5-21.6-4.5c-8.4-3.3-13-14-10.2-24c1.3-4.8,4.2-8.7,8-11c3.8-2.3,8.2-2.7,12.2-1.1 c12.6,4.9,18.1,1.8,19.3-0.9c3.1-9.4,12.1-14.2,20.2-10.9l0,0c4,1.7,7.3,5.1,9.1,9.7c1.9,4.6,2.1,9.7,0.7,14.5 C367.4,556.6,355.8,575,332.5,575z M340.3,533.5L340.3,533.5C340.3,533.5,340.3,533.5,340.3,533.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M301.8,636.9c-7.7-1.8-15.8-5.3-23.9-10.3c-8.9-5.5-11.7-17.2-6.3-26.1c2.7-4.3,6.8-7.4,11.8-8.5 c4.9-1.2,10-0.4,14.4,2.3c13.4,8.2,20.4,6.7,22.5,4.4c5.8-8.3,17.2-10.6,25.8-5.1l0,0c4.3,2.7,7.2,7,8.3,11.9 c1.1,5,0.2,10-2.6,14.3C346.2,628.5,328.6,643.3,301.8,636.9z M320.3,598.6L320.3,598.6C320.3,598.6,320.3,598.6,320.3,598.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M313.3,651c-7.4,0-13.4-7.1-13.4-15.8v-95.7c0-8.7,6-15.8,13.4-15.8s13.4,7.1,13.4,15.8v95.7 C326.6,643.9,320.6,651,313.3,651z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M292.4,575c-23.2,0-34.8-18.4-37.7-28.1c-1.4-4.8-1.2-10,0.7-14.5c1.9-4.6,5.1-8,9.1-9.7 c8.1-3.4,17,1.5,20.2,10.9c1.3,2.7,6.7,5.8,19.3,0.9c4.1-1.6,8.4-1.2,12.2,1.1c3.8,2.3,6.7,6.2,8,11c1.3,4.8,1,9.9-0.9,14.5 c-1.9,4.5-5.2,7.9-9.3,9.5C306.4,573.5,299.1,575,292.4,575z M284.6,551.8C284.6,551.8,284.6,551.8,284.6,551.8 S284.6,551.8,284.6,551.8z"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M389.1,442.3c-4.9,23.3-23.9,32.5-46.6,32.5h-59.4c-22.7,0-41.7-9.2-46.6-32.5h-17.8l-9.2,0 c0,32.8,33.4,56.7,63.2,56.7h80.2c29.8,0,54-24,54-56.7v0H389.1z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M789,230"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M549.6,727.5H84.4c-7.3,0-13.2,5.9-13.2,13.2V751c0,7.3,5.9,13.2,13.2,13.2H127l-8.4,159.1h-0.5v8.8 l-10.6,201.2H143l14.6-178h328.8l14.6,178h35.5l-19.5-369h32.6c7.3,0,13.2-5.9,13.2-13.2v-10.3 C562.8,733.5,556.9,727.5,549.6,727.5z M476.3,831.3l7.5,91.9H160.2l7.5-91.9H476.3z M170.4,799.4l2.9-35.2h297.5l2.9,35.2H170.4z"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M320.4,443.9c0,8.6,6.1,15.5,13.6,15.5h20.4c5.5,0,10.5-3.8,12.6-9.5c1-2.8,1.9-5.6,2.7-8.6h-49.4V443.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M257.9,449.9c2.1,5.8,7.1,9.5,12.6,9.5h20.4c7.5,0,13.6-6.9,13.6-15.5v-2.6h-49.4 C256,444.2,256.9,447.1,257.9,449.9z"
  })))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M767.1,165.3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeaverScreening);
export default __webpack_public_path__ + "static/media/Beaver-screening.c9f257a03647aafe9a5560a2a71faaf9.svg";
export { ForwardRef as ReactComponent };